import React, { Suspense, lazy } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

const Index = lazy(() => import("../views/home/Index"));
const AboutUs = lazy(() => import("../views/home/AboutUs"));
const FAQ = lazy(() => import("../views/home/FAQ"));
const MDDS = lazy(() => import("../views/home/MDDS"));
/* const MDDSold = lazy(() => import("../views/home/MDDSold")); */
const ContactUs = lazy(() => import("../views/home/ContactUs"));
const PageNotFound = lazy(() => import("../views/home/PageNotFound"));

const Indexsbd = lazy(() => import("../views/homesbd/Index"));
const AboutUssbd = lazy(() => import("../views/homesbd/AboutUs"));
const FAQsbd = lazy(() => import("../views/homesbd/FAQ"));
const Shabdkosh = lazy(() => import("../views/homesbd/Shabdkosh"));
const ShabdkoshPDF = lazy(() => import("../views/homesbd/ShabdkoshPDF"));
const GoogleSearch = lazy(() => import("../views/homesbd/GoogleSearch"));
const ShabdkoshTreeView = lazy(() =>
  import("../views/homesbd/ShabdkoshTreeView")
);
const ContactUssbd = lazy(() => import("../views/homesbd/ContactUs"));
const Routers = () => {
  return (
    <Router>
      <Suspense fallback="">
        <Routes>
          <Route path="/error" exact component={<Index />} />
          <Route path="/" exact element={<Index />} />
          <Route path="/about-us" element={<AboutUs />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/contact-us" element={<ContactUs />} />
          <Route path="/mdds" element={<MDDS />} />
          {/* <Route path="/mddsold" element={<MDDSold />} /> */}
          <Route path="/shabdkosh/home" exact element={<Indexsbd />} />
          <Route path="/shabdkosh/about-us" element={<AboutUssbd />} />
          <Route path="/shabdkosh/faq" element={<FAQsbd />} />
          <Route path="/shabdkosh/contact-us" element={<ContactUssbd />} />
          <Route path="/shabdkosh" element={<Shabdkosh />} />
          <Route path="/shabdkoshpdf" element={<ShabdkoshPDF />} />
          <Route path="/shabdkoshview" element={<ShabdkoshTreeView />} />
          <Route path="/googlesearch" element={<GoogleSearch />} />
          <Route path="/static/js/*" element={<PageNotFound />} />
          <Route path="*" exact element={<PageNotFound />} />
        </Routes>
      </Suspense>
    </Router>
  );
};
export default Routers;
